import { Navigate, Outlet, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import type { Eu } from '../api';
import type { AbaModulo, ModuloWeb } from '../modulos';
import { PaginaSecao } from '../ui/PaginaSecao';
import { Vazio } from '../ui/Estados';

export interface AbaResolvida extends AbaModulo {
  slug: string;
  rota: string;
}

/** Abas visíveis de um menu: módulos instalados no tenant e permissão da aba. */
export function abasDoMenu(menu: string, modulos: ModuloWeb[], eu: Eu): AbaResolvida[] {
  const tudo = eu.permissoes.includes('*');
  return modulos
    .filter((m) => m.menu === menu && (eu.modulos ?? []).includes(m.slug))
    .flatMap((m) => m.abas.map((a) => ({ ...a, slug: m.slug, rota: `/${menu}/${a.caminho}` })))
    .filter((a) => tudo || eu.permissoes.includes(a.permissao ?? `${a.slug}.ler`))
    .sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0));
}

/** F6: página de seção gerada para o menu; os submenus são abas, a ação primária vem da aba ativa. */
export function Secao({ menu, modulos, eu }: { menu: string; modulos: ModuloWeb[]; eu: Eu }) {
  const { t } = useTranslation();
  const local = useLocation();
  const abas = abasDoMenu(menu, modulos, eu);
  const ativa = abas.find((a) => local.pathname === a.rota || local.pathname.startsWith(`${a.rota}/`));
  if (!abas.length) {
    return (
      <PaginaSecao kicker={t(`menu.${menu}`)} titulo={t(`menu.${menu}`)}>
        <Vazio titulo={t('secao.semAbasTitulo')} texto={t('secao.semAbasTexto')} />
      </PaginaSecao>
    );
  }
  if (!ativa) return <Navigate to={abas[0]!.rota} replace />;
  const Acao = ativa.Acao;
  const buscaDemo = new URLSearchParams(local.search).get('demo') === '1' ? '?demo=1' : '';
  return (
    <PaginaSecao
      kicker={t(`menu.${menu}`)}
      titulo={t(ativa.rotulo, { ns: ativa.slug })}
      acao={Acao ? <Acao /> : undefined}
      abas={abas.map((a) => ({ rotulo: t(a.rotulo, { ns: a.slug }), rota: a.rota + (menu === 'mutualforce' ? a.caminho === 'agentes' ? local.search : buscaDemo : '') }))}
    >
      <Outlet context={eu} />
    </PaginaSecao>
  );
}
